import jwt from "jsonwebtoken";

export const decodeToken = (token: string) => jwt.decode(token);

export const isTokenExpired = (token: string) => {
  const payload = decodeToken(token)! as jwt.JwtPayload;
  return payload.exp! < Math.trunc(new Date().getTime() / 1000);
};
